import { useMemo, useState } from "react";
import { breakingNews } from "@/mocks/gossip";

export default function BreakingCards() {
  const [shuffled, setShuffled] = useState(false);

  const list = useMemo(() => {
    const base = [...breakingNews];
    if (!shuffled) return base;
    return base.sort(() => Math.random() - 0.5);
  }, [shuffled]);

  return (
    <section
      id="hot"
      className="scroll-mt-24 w-full bg-background-100 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-primary-600">
              <i className="ri-flashlight-line h-4 w-4 flex items-center justify-center text-accent-500" />
              BREAKING · 最新爆料
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              这些瓜正在发酵
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              编辑团队跟进整理，尽量让你一条看完前因后果。
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShuffled((v) => !v)}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-600 hover:text-background-50"
          >
            <i className="ri-refresh-line h-4 w-4 flex items-center justify-center" />
            {shuffled ? "恢复默认排序" : "换一批瓜"}
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-lift"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.category}${item.title}最新爆料图`}
                  title={`${item.title} - 99吃瓜`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-background-50/95 px-2.5 py-1 text-xs font-medium text-primary-700">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 left-3 rounded-full bg-primary-950/70 px-2.5 py-0.5 text-[11px] text-background-50 backdrop-blur">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-label text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line h-3.5 w-3.5 flex items-center justify-center" />
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1 font-medium text-accent-600">
                    <i className="ri-fire-fill h-3.5 w-3.5 flex items-center justify-center" />
                    热度 {item.heat}万
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}